<script>
  import viewport from '@/js/utils/useViewportAction.js';

  export let content;
  let grow = false;
</script>

<div
  class="entry-content"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  {@html content}
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  :global {
    .entry-content {
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
      hr {
        border-top: 1px solid $light-border;
        border-bottom: transparent;
        margin: 4rem 0;
      }
      p,
      h5,
      h6 {
        margin: 4rem 0 0;
      }

      p:first-child {
        margin: 0;
      }

      h2,
      h3,
      h4 {
        margin: 6rem 0 0;

        @include resp-max('s') {
          text-align: center;
        }
      }

      ul {
        margin: 4rem 0 0;
        padding: 0;
        list-style: none;

        @include resp-max('s') {
          margin: 2.5rem 0 0;
        }

        li {
          position: relative;
          font-size: 1.6rem;
          line-height: 1.6;
          margin: 0 0 0 5.6rem;

          @include resp-max('s') {
            margin: 0 0 0 3.6rem;
          }

          &::before {
            content: '';
            border-bottom: 1.5px solid var(--aqua-1);
            width: 1.9rem;
            position: absolute;
            top: 1.15rem;
            left: -5.6rem;

            @include resp-max('s') {
              left: -3.6rem;
            }
          }

          a {
            color: var(--aqua-1);
          }
        }

        li:not(:first-child) {
          margin-top: 2.5rem;
        }
      }

      ::-moz-selection {
        /* Code for Firefox */
        color: rgb(var(--white));
        background: var(--royal);
        cursor: pointer;
      }

      ::selection {
        color: rgb(var(--white));
        background: var(--royal);
        cursor: pointer;
      }

      ol {
        margin: 4rem 0 0;
        padding: 0;
        list-style: none;
        counter-reset: list;

        li {
          counter-increment: list;
          font-size: 1.6rem;
          line-height: 1.6;
          margin: 0 0 0 3.7rem;
          position: relative;

          a {
            color: var(--aqua-1);
            display: inline;
          }

          &::before {
            content: '0' counter(list);
            color: var(--royal-light);
            position: absolute;
            margin-left: -3.7rem;
          }

          &::after {
            content: '';
            border-bottom: 1.5px solid var(--aqua-1);
            width: 1.9rem;
            position: absolute;
            top: 3.5rem;
            left: -3.7rem;
          }
        }

        li:not(:first-child) {
          margin-top: 2.5rem;
        }
      }
      table {
        margin-top: 4rem;
        padding: 0;
        font-size: 1.6rem;
        line-height: 1.6;
        a {
          color: var(--aqua-1);
        }

        th {
          padding: 1rem 0;
          color: var(--royal-light);
          text-align: left;
          &:not(:last-child) {
            padding-right: 3rem;
          }
        }
        td {
          border-top: 1px solid;
          border-image-slice: 3;
          border-image-source: url(img/line-dots-horizontal.svg);
          border-image-repeat: round;

          padding: 3rem 0;
          color: var(--royal);
          vertical-align: top;
          width: 30%;

          &:not(:last-child) {
            padding-right: 3rem;
          }
        }
      }

      .listed-text-block {
        margin: 4rem 0 0 0;

        h5 {
          margin: 4rem 0 0;
        }
        p {
          margin: 1.5rem 0 0;
          color: var(--royal-light);
          font-size: 1.6rem;
          list-style: 1.6;
        }
      }

      .text-center {
        text-align: center;
      }

      .aligncenter {
        margin: 0 auto;
      }

      .text-alt-color {
        color: var(--royal-light);
      }
    }

    .single-vacancy {
      background-color: aqua;
      .entry-content {
        ul {
          li {
            position: relative;
            font-size: 1.6rem;
            line-height: 1.6;
            margin: 0 0 0 3.5rem;

            &::before {
              content: '';
              border-bottom: 1.5px solid var(--aqua-1);
              width: 1.9rem;
              position: absolute;
              top: 1.15rem;
              left: -3.5rem;
            }
            &:not(:first-child) {
              margin-top: 2.5rem;
            }
          }
        }
      }
    }

    .page-story {
      .entry-content {
        .two-columns {
          p {
            color: var(--royal-light);

            @include resp-max('s') {
              margin-top: 1.5rem;
            }
          }

          h5 {
            @include resp-max('s') {
              margin-top: 3rem;
            }
          }
        }
      }
    }
  }
</style>
